import { AbacusIssuingDetailsInclude } from '@Shared/interfaces/CardsGatewayInterfaces';
import { Api as apiService } from '../api';
export class CardIssuingApiService {
    static post(body) {
        // TODO front-end error handling? Currently all exists on back-end, but we could preemptively check fields before allowing request to go through at all.
        return apiService
            .post('/api/web/accounts/cards/issue_card', body)
            .then((response) => response.json());
    }
    /**
     * Gets issuing details (card information, on the provider end) for a linked account.
     * @param linkedAccountId
     * @param includeShareableLink - denotes whether or not, in the response, to return a url to render a visual representation of the card
     * @returns {Object} - payload of request to provider for card issuing details.
     */
    static getIssuingDetails(linkedAccountId, includeSharedLink, includeExpenseTags) {
        const options = [];
        if (includeSharedLink) {
            options.push(['include', AbacusIssuingDetailsInclude.shared_link]);
        }
        if (includeExpenseTags) {
            options.push(['include', AbacusIssuingDetailsInclude.expense_tags]);
        }
        const urlParamsString = new URLSearchParams(options).toString();
        const url = `/api/web/accounts/cards/${linkedAccountId}/issuing_details${urlParamsString ? `?${urlParamsString}` : ''}`;
        return apiService.responseToJSONAndToastError(apiService.get(url));
    }
    static updateIssuingDetails(linkedAccountId, body) {
        // TODO front-end error handling? Currently all exists on back-end, but we could preemptively check fields before allowing request to go through at all.
        return apiService
            .put(`/api/web/accounts/cards/${linkedAccountId}/issuing_details`, body)
            .then((response) => response.json());
    }
    static getParentCards(programId) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/accounts/cards/${programId}/parent_cards`));
    }
    static getMerchantCategoryOptions() {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/accounts/cards/merchant_category_options`));
    }
    static getVendors() {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/accounts/cards/vendors`));
    }
    static getShippingOptions(programId) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/accounts/cards/${programId}/shipping_options`));
    }
    static getTransactions(linkedAccountId, state, options) {
        const searchParams = options ? new URLSearchParams(options).toString() : '';
        const url = `/api/web/accounts/cards/${linkedAccountId}/transactions/${state}?${searchParams}`;
        return apiService.responseToJSONAndToastError(apiService.get(url));
    }
    static searchTransactions(linkedAccountId, limit, offset, state, sortField, sortDirection) {
        const options = { limit: limit === null || limit === void 0 ? void 0 : limit.toString(), offset: offset === null || offset === void 0 ? void 0 : offset.toString() };
        if (state) {
            options.state = state;
        }
        if (sortField) {
            options.sortField = sortField;
            options.sortDirection = sortDirection;
        }
        const searchParams = new URLSearchParams(options).toString();
        return apiService.responseToJSONAndToastError(apiService.get(`api/web/accounts/cards/${linkedAccountId}/transactions?${searchParams}`));
    }
    // The URL for this request is returned from getIssuingDetails when includeSharedLink=true and the card is a gateway virtual card
    static getJsonCardImage(src) {
        return apiService.responseToJSON(fetch(src, { mode: 'cors' }));
    }
    static sendReminder(userId, message) {
        const url = `/api/web/accounts/cards/${userId}/remind`;
        return apiService.post(url, { message });
    }
    static sendBulkReminder(userIds, message) {
        const url = '/api/web/accounts/cards/bulk_remind';
        return apiService.post(url, { message, user_ids: userIds });
    }
    static uploadCSV(data, programId) {
        const url = '/api/web/accounts/cards/upload_csv';
        return apiService.post(url, { csv: data, accountId: programId }).then((response) => response.json());
    }
    static bulkIssueCards(cardsData, programId) {
        const url = '/api/web/accounts/cards/bulk_issue_cards';
        return apiService.post(url, { cardsData, parentLinkedAccountId: programId }).then((response) => response.json());
    }
}
